
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import HeaderService from "@/services/HeaderService";
import HeaderFooter from "@/models/Header_Footer/HeaderFooter";
import { AxiosResponse } from "axios";
import GlobalConfig from "@/GlobalConfig";
import AfiliadoService from "@/services/AfiliadoService";
import NoLoggedUser from "@/models/Sobrevivencia/NoLoggedUser/NoLoggedUser";
@Component({})
export default class Header extends Vue {
  public header: HeaderFooter = new HeaderFooter();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public headerService: HeaderService = new HeaderService();
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public redirectUrl: string = GlobalConfig.PORTAL_BASE_URL;
  public logoUrl: string = "";
  public name: string = "";
  public today: string = "";
  public isCollapsed: boolean = false;
  @Getter("noLoggedUser") noLoggedUser: NoLoggedUser;
  @Getter("isLoggedIn") isLoggedIn: boolean;

  async mounted() {
    var html = document.getElementsByTagName("html");
    for (var i = 0; i < html.length; i++) {
      html[i].style.overflow = "visible";
    }
    if (this.isLoggedIn) {
      this.name = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    }
    await this.getHeaderData();
    this.getTodaysDate();
  }
  public getTodaysDate() {
    let date = new Date();
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    this.today = date.toLocaleDateString("es-ES", options as any);
  }
  async getHeaderData() {
    this.headerService
      .get("MasterService/_umbracoMaster")
      .then((resp: AxiosResponse<HeaderFooter>) => {
        this.header = resp.data;
        this.logoUrl = `${this.umbracoBaseUrl}${resp.data.logo}`;
      });
  }
  public redirectHome() {
    window.location.href = GlobalConfig.PORTAL_BASE_URL;
  }

  public toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  async logOut() {
    this.afiliadoService.logOut(this.$store.state.sessionId);
    this.$store.dispatch("logOut");
    this.redirectHome();
  }
  public collapse(id: string) {
    let element = document.getElementById(id);
    element.classList.toggle("show");
  }
  public collapsed(id: string) {
    let element = document.getElementById(id);
    element.classList.toggle("collapsed");
  }
  @Watch("isLoggedIn")
  public setName(value: boolean) {
    if (value)
      this.name = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
  }

  public redirectDashboard() {
    this.$router.push("/Dashboard");
  }
  get isOutsideUser() {
    return !!this.noLoggedUser;
  }
}
